// =====================================
//
//   Home Controller
//   Author: Gray
//   createtime: 2016 / 02 / 16
//   Author: Alan
//	 updatetime: 2016 / 02 / 25
//   Author: Gray
//   updatetime: 2016 / 03 / 11
//
// =====================================

angular.module("InifECMobileApp").controller("FbLoginSuccessController", [
  "$q",
  "$scope",
  "$rootScope",
  "$timeout",
  "FacebookService",
  function (
    $q,
    $scope,
    $rootScope,
    $timeout,
    FacebookService,
  ) {
    //接下回傳網址中的token
    var getFbAccessToken = function () {
      $scope.accessToken = window.location.hash.split("&")[0].split("=")[1];
    };

    //利用接收到的token請求或取fb資料，送入後端並讓使用者登入
    var loginWithFacebook = function () {
      var defer = $q.defer();
      let accesstoken = $scope.accessToken;
      FacebookService.loginWithFBAccesstoken(undefined, accesstoken).then(
        function (result) {
          defer.resolve(result);

          $scope.isLoginWithFacebook = true;

          $timeout(function () {
            $rootScope.$broadcast("LOGIN_SUCCESS");

            $rootScope.$broadcast("OPEN_LOADING_SUCCESS_MODAL", {
              title: "登入成功",
            });
          }, 500);

          $timeout(function () {
            window.location.href = window.location.origin;
          }, 1000);
        },
        function (error) {
          $scope.isLoginWithFacebook = false;
          defer.reject(error);
          console.error(
            "[App4Fx Error] : FacebookService.loginWithFacebook request error."
          );
          console.error("error : " + error);
        }
      );
      return defer.promise;
    };

    var init = function () {
      getFbAccessToken();
      loginWithFacebook();
    };

    //==========================
    //  Events
    //==========================

    //==========================
    //  Members
    //==========================
    $scope.accessToken = "";
    $scope.isLoginWithFacebook = false;

    //==========================
    //  Methods
    //==========================
    $scope.getFbAccessToken = getFbAccessToken;
    $scope.loginWithFacebook = loginWithFacebook;

    //==========================
    //  Init
    //==========================
    init();
  },
]);
